import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import App from "./app";
import "./i18n";
import "./index.css";

/**
 * Light by default, on every device (Mo's standing rule for every Gymkee surface: light first,
 * dark supported). A payment page opened from a dark phone is still paper: the coach's client
 * meets the same page the coach saw when he sent the link. `data-theme="dark"` on the root is
 * the switch every `--gk-*` token reads; it is set only when the link asks for it explicitly
 * (`?theme=dark`), which is how the dark renders are gated, never from the system setting.
 */
function applyTheme() {
  const wanted = new URLSearchParams(window.location.search).get("theme");
  document.documentElement.dataset.theme = wanted === "dark" ? "dark" : "light";
}

applyTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1 },
  },
});

const rootElement = document.getElementById("root") as HTMLElement;
createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
